"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.footerLogos = exports.Footer = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _LockIcon = _interopRequireDefault(require("./assets/LockIcon.svg"));
var _PlaidMazoomaLogo = _interopRequireDefault(require("./assets/PlaidMazoomaLogo.svg"));
var _PayDirectLogo = _interopRequireDefault(require("./assets/PayDirectLogo.svg"));
var _templateObject, _templateObject2;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
const fontRules = "\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 12px;\n  letter-spacing: 0.15px;\n  color: rgba(0, 0, 0, 0.54);\n";
const FooterWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  height: ", ";\n  background: #ffffff;\n  box-shadow: 0px -5px 10px -5px rgba(0, 0, 0, 0.2),0px -10px 24px -15px rgba(0, 0, 0, 0.14), 0px -5px 30px -15px rgba(0, 0, 0, 0.12);\n  position: fixed;\n  left: 0px;\n  bottom: 0px;\n  transition: height 0.2s;\n  ", "\n\n  .body {\n    height: 95px;\n    border-top: 1px solid rgba(0, 0, 0, 0.1);\n    padding: 20px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    gap: 12px;\n  }\n"])), props => props.active === "true" ? "200px" : "65px", fontRules);
const Tray = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  height: 65px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n\n  .header {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 4px;\n    height: 65px;\n  }\n\n  .lockIcon {\n    height: 24px;\n    width: 24px;\n  }\n\n  span {\n    margin-top: 1px;\n    ", "\n  }\n"])), fontRules);
const footerLogos = exports.footerLogos = ["plaidMazooma", "payDirect"];
const integrationLogos = {
  plaidMazooma: /*#__PURE__*/_react.default.createElement("img", {
    className: "platformLogo",
    src: _PlaidMazoomaLogo.default,
    alt: "PlaidMazoomaLogo"
  }),
  payDirect: /*#__PURE__*/_react.default.createElement("img", {
    className: "platformLogo",
    src: _PayDirectLogo.default,
    alt: "PayDirectLogo"
  })
};
const integrationBodyContent = {
  plaidMazooma: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("b", null, "Mazooma"), " securely connects you to your bank for deposits using online banking."), /*#__PURE__*/_react.default.createElement("span", null, "No Mazooma signup required."), /*#__PURE__*/_react.default.createElement("span", null, "All U.S. banks are supported.")),
  payDirect: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("b", null, "PayDirect"), " securely connects you to your bank for deposits using online banking."), /*#__PURE__*/_react.default.createElement("span", null, "No PayDirect signup required."), /*#__PURE__*/_react.default.createElement("span", null, "All U.S. banks are supported."))
};
class Footer extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      active: false
    };
    this.toggle = this.toggle.bind(this);
  }
  toggle() {
    this.setState({
      active: !this.state.active
    });
  }
  render() {
    const {
      integration,
      wrapperProps,
      ...props
    } = this.props;
    const {
      active
    } = this.state;
    const logo = integration ? integrationLogos[integration] : integrationLogos[footerLogos[0]];
    const bodyContent = integration ? integrationBodyContent[integration] : integrationBodyContent[footerLogos[0]];
    return /*#__PURE__*/_react.default.createElement(FooterWrapper, _extends({
      "data-test": "footer",
      active: this.state.active.toString()
    }, wrapperProps), /*#__PURE__*/_react.default.createElement(Tray, _extends({
      onClick: this.toggle,
      className: "footer"
    }, props), /*#__PURE__*/_react.default.createElement("div", {
      className: "header"
    }, /*#__PURE__*/_react.default.createElement("img", {
      className: "lockIcon",
      src: _LockIcon.default,
      alt: "LockIcon"
    }), /*#__PURE__*/_react.default.createElement("span", null, "Secure connection by"), logo)), active && /*#__PURE__*/_react.default.createElement("div", {
      className: "body"
    }, bodyContent));
  }
}
exports.Footer = Footer;
Footer.propTypes = {
  integration: _propTypes.default.oneOf(footerLogos)
};
Footer.defaultProps = {
  integration: "plaidMazooma"
};